/**
 * @Author：zsj
 * @Date：2022/03/11
 */

const UPDATE_HOME_DATA = 'UPDATE_HOME_DATA'

export default {
    UPDATE_HOME_DATA
}
